import { render } from "./ModalNuevoEquipo.vue?vue&type=template&id=87e05120"
import script from "./ModalNuevoEquipo.vue?vue&type=script&lang=js"
export * from "./ModalNuevoEquipo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/maguilar/Dev/repos/garantias-transelec/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__